import { ActionCreators } from 'redux-undo-immutable';
import { batchHiddenActions } from 'Reducers/batchReducer';
import * as editActions from './editActions';
import { deselectAssetsAndFolders } from './folderAssetActions';
import { getEaselMidPoint } from '../selectors';

export const toggleAnimationDrawer = () => ({
  type: 'TOGGLE_ANIMATION_DRAWER',
});

export const zoomReset = () => ({
  type: 'ZOOM_RESET',
});

export const zoomIn = () => (dispatch, getState) => {
  const point = getEaselMidPoint(getState());
  const delta = -0.1;
  const percentages = { x: 0.5, y: 0.5 };
  dispatch({
    type: 'ZOOM_ABOUT_POINT',
    point,
    delta,
    percentages,
  });
};

export const zoomOut = () => (dispatch, getState) => {
  const point = getEaselMidPoint(getState());
  const delta = 0.1;
  const percentages = { x: 0.5, y: 0.5 };
  dispatch({
    type: 'ZOOM_ABOUT_POINT',
    point,
    delta,
    percentages,
  });
};

export const easelOffsetMove = (deltaX, deltaY) => ({
  type: 'EASEL_OFFSET_MOVE',
  deltaX,
  deltaY,
});

export const allowMultiSelectAssetModal = () => ({
  type: 'ALLOW_MULTI_SELECT_ASSET_MODAL',
});

export const disallowMultiSelectAssetModal = () => ({
  type: 'DISALLOW_MULTI_SELECT_ASSET_MODAL',
});

export const toggleAssetModal = () => (dispatch, getState) => {
  const state = getState();
  if (state.getIn(['ui', 'assetModalOpen'])) dispatch(deselectAssetsAndFolders());
  dispatch({
    type: 'TOGGLE_ASSET_MODAL',
  });
};
export const togglePublishModal = () => ({
  type: 'TOGGLE_PUBLISH_MODAL',
});

const mapMenuActionToReduxAction = (action) => {
  switch (action) {
    case 'undo': {
      return ActionCreators.undo;
    }
    case 'redo': {
      return ActionCreators.redo;
    }
    case 'cut': {
      return editActions.cutComponent;
    }
    case 'copy': {
      return editActions.copyComponent;
    }
    case 'paste': {
      return editActions.pasteComponents;
    }
    case 'pastespecial': {
      return editActions.pasteSpecialComponents;
    }
    case 'duplicate': {
      return editActions.duplicateComponents;
    }
    case 'remove': {
      return editActions.deleteComponents;
    }
    case 'bringForwards': {
      return editActions.bringComponentForwards;
    }
    case 'sendBackwards': {
      return editActions.sendComponentBackwards;
    }
    case 'menuPublish': {
      return togglePublishModal;
    }
    // TODO: Uncomment when grouping works
    // case 'group': {
    //   return editActions.groupComponents;
    // }
    // case 'ungroup': {
    //   return editActions.ungroupComponents;
    // }
    case 'zoomIn': {
      return zoomIn;
    }
    case 'zoomOut': {
      return zoomOut;
    }
    case 'zoomReset': {
      return zoomReset;
    }
    case 'menuAssets': {
      return [allowMultiSelectAssetModal, toggleAssetModal];
    }
    default:
      return null;
  }
};

export const menuAction = action =>
  (dispatch) => {
    const mappedAction = mapMenuActionToReduxAction(action);
    if (Array.isArray(mappedAction)) {
      mappedAction.forEach((act) => { dispatch(act()); });
    } else {
      dispatch(mappedAction());
    }
  };

export const setAssetModalMimeTypes = assetModalMimeTypes => ({
  type: 'SET_ASSET_MODAL_MIME_TYPES',
  assetModalMimeTypes,
});

export const toggleSettingsDrawer = () => ({
  type: 'TOGGLE_SETTINGS_DRAWER',
});

export const setSelectedfont = selectedfont => ({
  type: 'SET_SELECTED_fonts_FONT',
  selectedfont,
});

export const setSelectedfontWeight = selectedfontWeight => ({
  type: 'SET_SELECTED_fonts_FONT_WEIGHT',
  selectedfontWeight,
});

export const selectFirstfontWeight = () => ({
  type: 'SELECT_FIRST_fonts_FONT_WEIGHT',
});

export const toggleTextEditMode = () => ({
  type: 'TOGGLE_TEXT_EDIT_MODE',
});

export const enterTextEditMode = () => ({
  type: 'ENTER_TEXT_EDIT_MODE',
});

export const exitTextEditMode = () => ({
  type: 'EXIT_TEXT_EDIT_MODE',
});

export const setSelectBoxOpen = selectBoxOpen => ({
  type: 'SET_SELECT_BOX_OPEN',
  selectBoxOpen,
});

export const showCustomCursor = () => ({
  type: 'SHOW_CUSTOM_CURSOR',
});

export const hideCustomCursor = () => ({
  type: 'HIDE_CUSTOM_CURSOR',
});

export const setCustomCursorPosition = position => ({
  type: 'SET_CUSTOM_CURSOR_POSITION',
  position,
});

export const setCustomCursorRotation = (cardinal, rotation, cursorType) => ({
  type: 'SET_CUSTOM_CURSOR_ROTATION',
  cardinal,
  rotation,
  cursorType,
});

export const setCustomCursorType = cursorType => ({
  type: 'SET_CUSTOM_CURSOR_TYPE',
  cursorType,
});

export const updateCustomCursor = (cardinal, rotation, cursorType, position) => (dispatch) => {
  dispatch(batchHiddenActions([
    showCustomCursor(),
    setCustomCursorType(cursorType),
    setCustomCursorRotation(cardinal, rotation, cursorType),
    setCustomCursorPosition(position),
  ]));
};

export const zoomAboutPoint = (point, delta, percentages) => ({
  type: 'ZOOM_ABOUT_POINT',
  point,
  delta,
  percentages,
});

export const zoomToFitRect = rect => ({
  type: 'ZOOM_TO_FIT_RECT',
  rect,
});

export const setEaselSize = size => ({
  type: 'SET_EASEL_SIZE',
  size,
});

export const toggleFitAssetToLayer = () => ({
  type: 'TOGGLE_FIT_ASSET_TO_LAYER',
});

export const toggleOffsetHeight = () => ({
  type: 'TOGGLE_OFFSET_HEIGHT',
});

export const toggleViewport = () => ({
  type: 'TOGGLE_VIEWPORT',
});

export const toggleCodeModal = () => ({
  type: 'TOGGLE_CODE_MODAL',
});



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/actions/UIActions.js